import { InputProps } from 'antd'
import { getPhoneNumberMask } from 'shared/libs/phoneNumber'

import InputMask from 'react-input-mask'

import CustomTextFiled from 'shared/ui/Form/CustomTextFiled/CustomTextFiled'
import TextFiled from 'shared/ui/Form/TextFiled'

import './InputPhoneNumber.css'

export type InputPhoneNumberProps = InputProps & {
  onChange?: (value: string) => void
  value?: string
  inputType?: 'default' | 'custom'
  placeholderClassname?: string
  wrapperClassname?: string
}

const InputPhoneNumber = ({
  onChange,
  value,
  placeholderClassname,
  wrapperClassname,
  className,
  inputType = 'default',
  ...props
}: InputPhoneNumberProps) => {
  const { numberFormat: mask } = getPhoneNumberMask('KG')

  const handleValueChange = (newState: any, oldState: any) => {
    const rawValue = newState.value.replace(/\D/g, '')
    if (newState.value !== oldState.value || !value) {
      onChange?.(`+${rawValue}`)
    }
    return {
      ...newState,
    }
  }

  if (inputType === 'default') {
    return (
      // @ts-expect-error "@types/react-input-mask doesn't help to recognize type of input mask"
      <InputMask
        // @ts-expect-error "@types/react-input-mask doesn't help to recognize type of input mask params"
        formatChars={{
          '1': '[0-9]',
          a: '[A-Za-z]',
          '*': '[A-Za-z0-9]',
        }}
        maskChar={null}
        mask={mask}
        type="tel"
        value={value}
        beforeMaskedValueChange={handleValueChange}
        {...props}
      >
        {(inputProps) => (
          <TextFiled
            className={`phoneNumberInput ${className}`}
            type="tel"
            {...inputProps}
          />
        )}
      </InputMask>
    )
  }

  return (
    // @ts-expect-error "@types/react-input-mask doesn't help to recognize type of input mask"
    <InputMask
      // @ts-expect-error "@types/react-input-mask doesn't help to recognize type of input mask params"
      formatChars={{
        '1': '[0-9]',
        a: '[A-Za-z]',
        '*': '[A-Za-z0-9]',
      }}
      maskChar={null}
      mask={mask}
      value={value}
      type="tel"
      beforeMaskedValueChange={handleValueChange}
      {...props}
    >
      {(inputProps) => (
        <CustomTextFiled
          wrapperClassname={wrapperClassname}
          placeholderClassname={placeholderClassname}
          className={`phoneNumberInput ${className}`}
          type="tel"
          {...inputProps}
        />
      )}
    </InputMask>
  )
}

export default InputPhoneNumber
